import React from 'react';
import { Box, Typography } from 'web-library';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';


import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  modeLabel: {
    marginBottom: theme.spacing(3),
  },
  optionContainer: {
    marginBottom: theme.spacing(3),
  },
  radioGroupRoot: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export interface UploadOptionActionProps {
  /** define upload option value
   * */
  uploadOptionValue: boolean;
  /** define upload option on change
   * */
  onUploadOptionChange: () => void;
}

const UploadOptionAction = (props: UploadOptionActionProps) => {
  const { uploadOptionValue = true, onUploadOptionChange = () => null } = props;
  const { classes: useClasses } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={useClasses.modeLabel}>
        <Typography variant="h3">
          {t('resit->>CoordinatorResit.Select Mode of Registration')}
        </Typography>
      </Box>

      <div
        id="coordinator-resit-register-upload-option-container"
        className={useClasses.optionContainer}
      >
        <RadioGroup
          aria-label="upload-option"
          name="upload-option"
          className={useClasses.radioGroupRoot}
          value={uploadOptionValue}
          onChange={onUploadOptionChange}
        >
          <FormControlLabel
            id="radio-manual"
            value={false}
            control={<Radio />}
            label={t('resit->>Register Individual Candidate(s) Manually')}
          />
          <FormControlLabel
            id="radio-bulkUpload"
            value
            control={<Radio />}
            label={t('resit->>RegisterResit.Bulk Upload using a .csv template')}
          />
        </RadioGroup>
      </div>
    </>
  );
};
export default UploadOptionAction;
